export default function profile() {
  const urlParams = new URLSearchParams(window.location.search)
  const myParam = urlParams.get('profileID')
  if (myParam) {
    document.cookie = `profileID=${myParam};expires='session';path=/`
  }
}
